import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=a0aa6bf6&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0aa6bf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0aa6bf6')) {
      api.createRecord('a0aa6bf6', component.options)
    } else {
      api.reload('a0aa6bf6', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=a0aa6bf6&scoped=true&", function () {
      api.rerender('a0aa6bf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2K89EFl6jvOKG/JS/comp/SearchFilterTokens.vue"
export default component.exports